import { render, staticRenderFns } from "./changeCardList.vue?vue&type=template&id=38e92124&scoped=true"
import script from "./changeCardList.vue?vue&type=script&lang=js"
export * from "./changeCardList.vue?vue&type=script&lang=js"
import style0 from "./changeCardList.vue?vue&type=style&index=0&id=38e92124&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e92124",
  null
  
)

export default component.exports